import { usePaymentPlan } from "../../../../../../PaymentPlan/hooks/usePaymentPlan";
import { useContext, useEffect, useState } from "react";
import { PaymentPlanLineStatus } from "@nemuru-eng/js-api-client";
import { PaymentResultType } from "../../../../../../PaymentResult/types/PaymentResultType";
import { ProcessContext } from "../../../../../../../../../../../contexts/ProcessContext";

const TIMEOUT = 1200;
const MAX_RETRIES = 10;

export const useFlywireCallback = (paymentPlanLineId) => {
  const { dispatch } = useContext(ProcessContext);

  const {
    getPaymentPlanByPaymentPlanLineId,
    patchUpdatePaymentPlanLineStatus,
    currentPaymentPlanLine,
  } = usePaymentPlan(paymentPlanLineId);

  const [retries, setRetries] = useState(0);
  const [result, setResult] = useState();

  useEffect(() => {
    patchUpdatePaymentPlanLineStatus(PaymentPlanLineStatus.PROCESSING);
  }, []);

  useEffect(() => {
    if (retries >= MAX_RETRIES && currentPaymentPlanLine) {
      if (currentPaymentPlanLine.status === PaymentPlanLineStatus.PROCESSING) {
        handleProcessing();
        return;
      }
      handleError();
      return;
    }
    setTimeout(() => handleRetry(), TIMEOUT);
  }, [currentPaymentPlanLine]);

  const handleRetry = () => {
    if (
      currentPaymentPlanLine &&
      currentPaymentPlanLine.status === PaymentPlanLineStatus.PAID
    ) {
      setResult(PaymentResultType.SUCCESS);
      setFlowLoading(false);
      return;
    }
    getPaymentPlanByPaymentPlanLineId();
    setRetries(retries + 1);
  };

  const handleProcessing = () => {
    setFlowLoading(false);
    setResult(PaymentResultType.PROCESSING);
  };

  const handleError = () => {
    setFlowLoading(false);
    setResult(PaymentResultType.ERROR);
  };

  const setFlowLoading = (show) =>
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show },
    });

  return { result };
};
